import { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "./CustomModal.css";

function CustomModal(props) {
    const defaultProps = {
        showButtons: true,
        showHeader: true,
        size: ''
    }

    let content = props.content;

    if (!props.content?.type) {
        content = <></>;
    }

    useEffect(() => {
        if (!props.content?.type) {
            props.handleClose();
        }
    }, []);

    props = { ...defaultProps, ...props };
    return (
        <>
            <Modal dialogClassName={props.modalXXL && "custom-modal-size"} show={props.show} onHide={props.handleClose} size={!props.modalXXL && props.size}>
                {props.showHeader && (
                    <div className="modal-header">
                        <h4 className="modal-title">{props.title}</h4>
                        <button onClick={props.handleClose} type="button" className="bnt-close close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                <Modal.Body>{content}</Modal.Body>
                {props.showButtons && (
                    <Modal.Footer>
                        <Button variant="secondary" onClick={props.handleCancel}>
                            {props.cancelButtonText ?? 'Não'}
                        </Button>
                        <Button variant="primary" onClick={props.handleConfirm}>
                            {props.confirmButtonText ?? 'Sim'}
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        </>
    );
}

export default CustomModal;
